/*
 * FavoritesPage Messages
 *
 * This contains all the text for the FavoritesPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.Favorite';

export default defineMessages({
  pageTitle: {
    id: `${scope}.page.title`,
    defaultMessage: 'Workspace',
  },
  pageDescription: {
    id: `${scope}.page.description`,
    defaultMessage: 'CDP Workspace',
  },
  favorites: {
    id: `${scope}.page.favorites`,
    defaultMessage: 'Favorites',
  },
  favoriteEmptyMessage1: {
    id: 'favoriteEmptyMessage1',
    defaultMessage: 'No favorites to show yet. You can',
  },
  favoriteEmptyMessage2: {
    id: 'favoriteEmptyMessage2',
    defaultMessage: 'add courses to favorites after you',
  },
  favoriteEmptyMessage3: {
    id: 'favoriteEmptyMessage3',
    defaultMessage: 'create or access them',
  },
  favoriteErrorMessage1: {
    id: 'favoriteErrorMessage1',
    defaultMessage: 'There was a problem downloading content.',
  },
  favoriteErrorMessage2: {
    id: 'favoriteErrorMessage2',
    defaultMessage: 'Please try again later.',
  },
});
